module.exports = __webpack_public_path__ + "img/dzsungel80.98f9da91.jpg";